var ValidationMetadataProvider_1;
import { __decorate, __metadata } from "tslib";
import * as validator from "@leavy/validator/lib/base/validator";
import { injectable } from "inversify";
let ValidationMetadataProvider = ValidationMetadataProvider_1 = class ValidationMetadataProvider {
    constructor() {
        this.metadataCache = new Map();
        this.classValidatorMetadataStorage = validator.getMetadataStorage();
    }
    static get default() {
        return this._default ??= new ValidationMetadataProvider_1();
    }
    getValidationMetadataForTarget(objectOrClass) {
        const target = typeof objectOrClass === "function" ? objectOrClass : objectOrClass.constructor;
        if (this.metadataCache.has(target)) {
            return this.metadataCache.get(target);
        }
        const classValidatorValidationMetadatas = this.classValidatorMetadataStorage.groupByPropertyName(this.classValidatorMetadataStorage.getTargetValidationMetadatas(target, "", true, false));
        const objectValidationMetadata = {
            target,
            properties: {},
        };
        for (const [propertyName, cvValidationMetadataList] of Object.entries(classValidatorValidationMetadatas)) {
            const propertyMetadata = {
                propertyName,
                rules: [],
            };
            for (const cvValidationMetadata of cvValidationMetadataList) {
                const [rule] = this.classValidatorMetadataStorage.getTargetValidatorConstraints(cvValidationMetadata.constraintCls);
                if (!rule)
                    continue;
                propertyMetadata.rules.push({
                    name: rule.name,
                    each: cvValidationMetadata.each,
                    constraints: cvValidationMetadata.constraints ?? [],
                });
            }
            objectValidationMetadata.properties[propertyName] = propertyMetadata;
        }
        this.metadataCache.set(target, objectValidationMetadata);
        return objectValidationMetadata;
    }
    getPropertyDependencies(objectOrClass, propertyKey) {
        const metadata = this.getValidationMetadataForTarget(objectOrClass);
        const propertyMetadata = metadata.properties[propertyKey];
        if (propertyMetadata) {
            const dependencyRules = propertyMetadata
                .rules
                .filter(x => x.name == "dependsOn")
                .map(x => x.constraints[0]);
            return dependencyRules;
        }
        return [];
    }
};
ValidationMetadataProvider = ValidationMetadataProvider_1 = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], ValidationMetadataProvider);
export { ValidationMetadataProvider };
//# sourceMappingURL=ValidationMetadataProvider.js.map